import { useEffect, useState } from 'react';
import {
  flip,
  useFloating,
  useInteractions,
  useClick,
  useDismiss,
  autoUpdate,
  shift,
  type Placement,
  offset,
  autoPlacement,
} from '@floating-ui/react';

export const useFoldoutMenu = ({
  placement = 'bottom-end',
  offset: _offset = 4,
  fallbackPlacements,
}: {
  placement?: Placement;
  offset?: number;
  fallbackPlacements?: Placement[];
} = {}) => {
  const [isOpen, setIsOpen] = useState(false);

  const [boundaryEl, setBoundaryEl] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const el = document.getElementById('page-container');

    setBoundaryEl(el);
  }, []);

  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,

    middleware: [
      flip({ fallbackPlacements }),
      shift({ boundary: boundaryEl ?? undefined }),
      autoPlacement({
        boundary: boundaryEl ?? undefined, // the external content area
        allowedPlacements: [placement, 'bottom-end'],
        padding: 4,
      }),
      shift({
        boundary: boundaryEl ?? undefined,
        padding: 4,
      }),
      offset(_offset),
    ],
    whileElementsMounted: autoUpdate,
  });

  const { getReferenceProps, getFloatingProps } = useInteractions([
    useClick(context),
    useDismiss(context),
  ]);

  return {
    refs,
    getReferenceProps,
    getFloatingProps,
    floatingStyles,
    setIsOpen,
    isOpen,
  };
};
